const EVENTS_TO_PREVENT_BUBBLING = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOver',
    'onMouseOut',
    'onMouseUp',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onBlur',
    'onChange',
    'onFocus',
    'onInput',
    'onInvalid',
    'onReset',
    'onSelect',
    'onSubmit',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onCopy',
    'onCut',
    'onPaste',
    'onWheel',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
];
const bubblingCancelHandler = (event) => event.stopPropagation();
const useNoBubbling = (props) => {
    return EVENTS_TO_PREVENT_BUBBLING.reduce((result, eventName) => {
        result[eventName] =
            props && eventName in props
                ? (event) => {
                    props[eventName](event);
                    bubblingCancelHandler(event);
                }
                : bubblingCancelHandler;
        return result;
    }, {});
};

export { useNoBubbling };
//# sourceMappingURL=useNoBubbling.js.map
